app.controller('forgetPasswordCtrl', function ($scope, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q) {

    $scope.user_reset = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: ''
    };

    //$scope.Email = '';

    $scope.UserNID = '';
    $scope.back = function () {
        $window.location.href = "#/dashboard";
    }

    $scope.working = false;
    $scope.loadMessage = 'Loading...';

    $scope.modalMessage = {
        message: '',
        param: {}
    };



    $scope.submit = function () {
        //ecnrypt email
        var key = CryptoJS.enc.Utf8.parse('123456789qwertyu'); // Panjang 16 byte untuk AES-128
        var iv = CryptoJS.enc.Utf8.parse('qwerty0987654321'); // Juga 16 byte

        var plaintext = $scope.user_reset.Email;

        var encrypted = CryptoJS.AES.encrypt(plaintext, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        var challenge = grecaptcha.getResponse();
        if (!challenge) {
            alert("Mohon ulangi centang captcha");
            return false;
        }

        var data = {
            Email: encrypted.toString(),
            challenge: challenge
        }

        $http({
            method: 'POST',
            url: '/service/client.svc/Forget_Password',
            data: {
                UserForget: data,

            },
        }).then(function (data) {
            $scope.working = false;
            if (data.data.d.result) {
                $scope.UserNID = data.data.d.UserNID;
                swal('Success', 'Please check your email', 'success').then(function () {
                    $window.location.href = "#/login/";
                });
            }
            else {
                swal('Error', 'error - ' + data.data.d.message, 'error');
            }


        }, function (error) {
            swal('Error', 'error ', 'error');
        });
    };

});
